import { render, staticRenderFns } from "./window-item-primary.vue?vue&type=template&id=5bc55f93&scoped=true&"
import script from "./window-item-primary.vue?vue&type=script&lang=js&"
export * from "./window-item-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc55f93",
  null
  
)

export default component.exports